const states = {
    0: "Detected",
    1: "Confirmed",
    2: "Controlled",
    3: "Escalating",
    4: "Remediated",
    5: "Undetected"
};

export default states;
 
